import {EL} from "../util/DomUtils";
import {IBlobStore} from "../IMemoRemote";
import {UiContext} from "../util/UiContext";
import {Memo} from "../Memo";


export class Minimap extends HTMLElement {
    renderScale = 0.1;
    baseWidth = 0;
    baseHeight = 0;
    canvas: HTMLCanvasElement;
    scrollCanvas: HTMLCanvasElement;
    memo: Memo;

    needsBaseUpdate = true;
    needsScrollUpdate = true;
    _callbackid;

    constructor() {
        super();
        const shadow = this.attachShadow({ mode: "open" });
        EL('style', {appendTo: shadow}, ':host { display: grid; }  canvas { width: 100%; grid-row: 1; grid-column: 1; }');

        this.canvas = EL("canvas", {appendTo: shadow});
        this.scrollCanvas = EL("canvas", {appendTo: shadow});

        this.scrollCanvas.onmousedown=this.scrollCanvas.onmousemove=(e) => {
            if (e.buttons === 1) {
                this.memo.scrollContainer.scrollTop = Math.max(0, e.layerY/this.renderScale * this.canvas.height / this.canvas.clientHeight - this.memo.scrollContainer.clientHeight/2);
                this.memo.scrollContainer.scrollLeft = Math.max(0, e.layerX/this.renderScale * this.canvas.width / this.canvas.clientWidth - this.memo.scrollContainer.clientWidth/2);
            }
        }
    }

    async drawImage(ctx: CanvasRenderingContext2D, blobStore: IBlobStore, mediaId, x, y, xx, yy): Promise<void> {
        if (!mediaId) return;
        try {
            const mediaUrl = await blobStore.getMediaURL(mediaId);
            return new Promise<void>((resolve, reject) => {
                var img = new Image();
                img.src = mediaUrl;
                img.onload = function () {
                    ctx.drawImage(img, x, y, xx, yy);
                    resolve();
                };
                img.onerror = reject;
            });
        }catch{}
    }

    async drawMemoToCanvas(ctx: CanvasRenderingContext2D, memo: Memo) {
        const items = Object.values(memo.items);
        ctx.fillStyle='#ededfd'
        ctx.fillRect(0,0,this.baseWidth*this.renderScale,this.baseHeight*this.renderScale);
        await this.drawImage(ctx, UiContext.instance.blobStore, memo.items.meta?.getString('memoBackgroundImage', ''), 0, 0, this.baseWidth*this.renderScale, this.baseHeight*this.renderScale);
        for(const item of items) {
            if (item.isDeleted) continue;
            ctx.beginPath();
            ctx.fillStyle = item.getString('backgroundColor','');
            ctx.strokeStyle = item.getString('border', '');
            ctx.rect(
                item.getInt('x',0)*this.renderScale, item.getInt('y',0)*this.renderScale,
                item.getInt('width',0)*this.renderScale, item.getInt('height',0)*this.renderScale
            );
            ctx.fill();
            await this.drawImage(ctx, UiContext.instance.blobStore, item.getString('image', ''),
                item.getInt('x',0)*this.renderScale, item.getInt('y',0)*this.renderScale,
                item.getInt('width',0)*this.renderScale, item.getInt('height',0)*this.renderScale  );
            ctx.stroke();
            ctx.closePath();
        }
    }

    connectedCallback() {
        if (this.memo) this.redraw();
    }

    updateMeasurements() {
        this.baseWidth = this.memo.memoWidth; this.baseHeight = this.memo.memoHeight;
        if (!this.canvas) return;
        this.canvas.width=this.baseWidth*this.renderScale; this.canvas.height=this.baseHeight*this.renderScale;
        this.scrollCanvas.width=this.baseWidth*this.renderScale; this.scrollCanvas.height=this.baseHeight*this.renderScale;
    }

    redraw() {
        if (this.baseWidth != this.memo.memoWidth || this.baseHeight != this.memo.memoHeight) this.updateMeasurements();
        this.needsBaseUpdate = true;
        this.needsScrollUpdate = true;
        this._render();
    }

    handleScroll() {
        this.needsScrollUpdate = true;
        this._render();
    }

    _render() {
        window.cancelAnimationFrame(this._callbackid);
        this._callbackid = window.requestAnimationFrame(() => {
            if (this.needsBaseUpdate) {
                const ctx = this.canvas.getContext("2d");
                this.drawMemoToCanvas(ctx, this.memo);
                this.needsBaseUpdate = false;
            }
            if (this.needsScrollUpdate) {
                const ctx = this.scrollCanvas.getContext("2d");
                ctx.clearRect(0, 0, this.baseWidth*this.renderScale, this.baseHeight*this.renderScale);
                ctx.beginPath();
                ctx.lineWidth = 4;
                ctx.strokeStyle = '#ff00ff';
                ctx.rect(this.memo.scrollContainer.scrollLeft * this.renderScale, this.memo.scrollContainer.scrollTop * this.renderScale,
                    this.memo.scrollContainer.clientWidth * this.renderScale, this.memo.scrollContainer.clientHeight * this.renderScale);
                ctx.stroke();
                ctx.closePath();
                this.needsScrollUpdate = false;
            }
        });
    }
}

customElements.define('memo-minimap', Minimap);
